// Minimal SSE frame parsing, scoped to this surface (mirrors the AskPerformYard util without
// importing across containers). Frames are `event: <type>\ndata: <json>` separated by `\n\n`.

export type ParsedSSEMessage = { eventType: string; data: Record<string, unknown> };

export const parseSSEMessage = (message: string): ParsedSSEMessage | null => {
	if (!message.trim()) return null;

	let eventType = "";
	let eventData = "";
	for (const line of message.split("\n")) {
		if (line.startsWith("event:")) {
			eventType = line.substring(6).trim();
		} else if (line.startsWith("data:")) {
			eventData = line.substring(5).trim();
		}
	}

	if (!eventType || !eventData) return null;

	try {
		return { eventType, data: JSON.parse(eventData) as Record<string, unknown> };
	} catch {
		return null;
	}
};

export const extractSSEMessages = (buffer: string): { messages: string[]; remainingBuffer: string } => {
	const parts = buffer.split("\n\n");
	const remainingBuffer = parts.pop() || "";
	return { messages: parts.filter((msg) => msg.trim().length > 0), remainingBuffer };
};
